import axios from "axios";

const api = axios.create({
  baseURL: "https://bdnatibaia.com.br/relogio/api",
});

export async function getAgenda() {
  try {
    return (await api.get("/agenda")).data;
  } catch (e) {
    console.error("API FAILED", e);
    return false;
  }
}

export async function setAgenda(horarios) {
  let paramJSON = horarios;

  return await api.post("/inseriragenda", paramJSON);
}

export async function deleteRegistro(id, senha) {
  let paramJSON = {
    id: id,
    senha: senha,
  };
  console.log("deleteRegistro", paramJSON);
  return await api.post("/deleteregistro/index.php", paramJSON);
}

export async function selectregistrosatuais(id) {
  return await api.get("/selectregistrosatuais?id=" + id);
}

export default api;
